import React from 'react';
import './loader.scss';

export const Loader = () => {
  return (
    <div className="super-sku-loading-container">
      Loading Options
      <div className="super-sku-loading-wrapper">
        <span className="segment-spinner segment-spinner" />
        <div className="loading-tile-wrapper">
          <div className="loading-tile" />
          <div className="loading-tile" />
          <div className="loading-tile" />
          <div className="loading-tile" />
          <div className="loading-tile" />
          <div className="loading-tile loading-tile--last" />
        </div>
      </div>
    </div>
  );
};
